import { EProductTourTargets, ESectionTrackStatus } from '@constants';
import { useTranslation } from 'react-i18next';

import { WidgetTitle, WidgetWrapper } from '../../../shared/WidgetShared.styles';
import { CountItem } from '../CountItem';

import { ProgressWithoutPlanificationChart } from './components/ProgressWithoutPlanificationChart';
import {
  CountWrapper,
  Wrapper,
  TitleWrapper,
  LoadingWrapper
} from './ProgressWithoutPlanification.styles';

import { SubscriptionsSelector } from '@/components/Form';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { useSubscriptionsTrackingStats } from '@/store';
import { useMySubscriptions } from '@/store';

export const ProgressWithoutPlanification = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const {
    subscriptionsTrackingStats,
    selectedSubscriptionIds,
    setSelectedSubscriptionIds,
    isLoading
  } = useSubscriptionsTrackingStats();
  const { filteredSubscriptions } = useMySubscriptions();

  if (!subscriptionsTrackingStats && !isLoading) return null;
  return (
    <WidgetWrapper id={EProductTourTargets.PROGRESS_WIDGET}>
      <Wrapper>
        <TitleWrapper>
          <WidgetTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {t('TOTAL_PROGRESS')}
          </WidgetTitle>
          <SubscriptionsSelector
            subscriptions={filteredSubscriptions}
            value={selectedSubscriptionIds}
            onSelectStore={setSelectedSubscriptionIds}
            style={{ width: 120, maxHeight: 32 }}
          />
        </TitleWrapper>

        {isLoading || !subscriptionsTrackingStats ? (
          <LoadingWrapper>
            <LoadingCircleSpinner />
          </LoadingWrapper>
        ) : (
          <>
            <ProgressWithoutPlanificationChart
              subscriptionsTrackingStats={subscriptionsTrackingStats}
            />
            <CountWrapper>
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.KNOWN]}
                title={t(ESectionTrackStatus.KNOWN)}
                color="green6"
              />
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.REVISED]}
                title={t(ESectionTrackStatus.REVISED)}
                color="orange6"
              />
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.SUMMARISED]}
                title={t(ESectionTrackStatus.SUMMARISED)}
                color="purple6"
              />
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.STUDIED]}
                title={t(ESectionTrackStatus.STUDIED)}
                color="black6"
              />
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.SEEN]}
                title={t(ESectionTrackStatus.SEEN)}
                color="blue4"
              />
              <CountItem
                value={subscriptionsTrackingStats[ESectionTrackStatus.NOT_STARTED]}
                title={t(ESectionTrackStatus.NOT_STARTED)}
                color="black4"
              />
            </CountWrapper>
          </>
        )}
      </Wrapper>
    </WidgetWrapper>
  );
};
